import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  GeneralContainer,
  ButtonBack,
  ContainerBack,
  SpanForm,
  SpanCaseId,
  ContentCard,
  TitleCard,
  ContentFooterCard,
  ContentLeftCard,
  ContentRightCard,
  TextInternalCard,
  TextCountComments,
  TextDateCard,
  TextIdCard,
  ContentHeaderCard,
  ContentPrincipalTitle,
  Hr,
  ContentHr,
} from "./MyCaseDetailContainer.styled";
import { ReactComponent as BackArrow } from "../../themes/Icons/back_arrow.svg";
import { clientPolicyIngsight } from "../../App";
import { useLazyQuery, useMutation } from "@apollo/client";
import { theme as themeConfig } from "../../themes/themes";
import {
  ADDITIONAL_DATA_BY_CASE_ID,
  ADDITIONAL_DATA_QUESTIONS_BY_FORM,
  CASE_BY_ID,
  COMMENTS_BY_CASE_ID,
  INSIGHT_POCS_LIST,
  NEXT_CASE_STATUSES_BY_CASE,
  PERMISSIONS_BY_CASE,
  POLICIES_BY_CASE,
  QUEUES_BY_CASE,
  SUBPOLICIES_BY_MAIN_POLICY,
} from "../../GraphQL/Queries";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  CHANGE_STATUS_CASE,
  CHANGE_STATUS_CASE_COMMENT,
  CREATE_ADDITIONAL_DATA_BY_CASE_ID,
  CREATE_CASE_COMMENT,
  UPDATE_CASE_COMMENT,
} from "../../GraphQL/Mutations";
import MyCaseDetailComponent from "../../components/MyCaseDetailComponent/MyCaseDetailComponent";
import TextsmsIcon from "@mui/icons-material/Textsms";
import ModalConfirmCaseUpdated from "../../components/ModalConfirmCaseUpdated/ModalConfirmCaseUpdated";

const MyCaseDetailContainer = () => {
  const location = useLocation();
  const history = useHistory();
  const [additionalDataPreview, setAdditionalDataPreview] = useState([]);
  const [detail, setDetail] = useState({});
  const [caseDetail, setCaseDetail] = useState({});
  const [comments, setComments] = useState([]);
  const [renderAgain, setrenderAgain] = useState(false);
  const [isEditComment, setIsEditComment] = useState(false);
  const [commentData, setCommentData] = useState();
  const [openAlert, setOpenAlert] = useState(null);
  const [modalAlertTitle, setModalAlertTitle] = useState(false);
  const [actionsList, setActionsList] = useState([]);
  const [actionSelected, setActionSelected] = useState(null);
  const [myListPolicies, setMyListPolicies] = useState([]);
  const [mySubPolicies, setMySubPolicies] = useState([]);
  const [myListQueues, setMyListQueues] = useState([
    { value: 1, label: "Queue One" },
    { value: 2, label: "Queue Two" },
  ]);
  const [myListInsightsPoc, setMyListInsightsPoc] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [beforeAdditionalData, setBeforeAdditionalData] = useState();
  const [additionalData] = useState({
    policiesIdDataQuestion: null,
    subPoliciesIdDataQuestion: null,
    policyCaseAdditonalDataPolicies: [],
    policyCaseAdditonalDataSubPolicies: [],
    queuesIdDataQuestion: null,
    policyCaseAdditonalDataQueues: [],
    marketsIdDataQuestion: null,
    marketsValue: [],
    totalMonthlyVolume: null,
    impactedVolumePercentage: null,
    impactedTimePerTransaction: null,
    timeUnitIdDataQuestion: null,
    timeUnit: "",
    errorPercentageInTheLastMonth: null,
    errorPercentageCalculation: "",
    insightPocsIdDataQuestion: null,
    policyCaseAdditonalDataInsightPocs: [],
    benefitEurosIdDataQuestion: null,
    benefitEuros: null,
    otherBenefit1IdDataQuestion: null,
    otherBenefit1: null,
    otherBenefit2IdDataQuestion: null,
    otherBenefit2: null,
    otherBenefit3: null,
    otherBenefit4: null,
    otherBenefit5: null,
    fileAttachedIdDataQuestion: null,
    fileAttached: "",
    fileAttachedBase64: "",
  });
  const [createAdditionalDataByCaseId] = useMutation(
    CREATE_ADDITIONAL_DATA_BY_CASE_ID,
    {
      client: clientPolicyIngsight,
    }
  );

  const [changeStatusCase] = useMutation(CHANGE_STATUS_CASE, {
    client: clientPolicyIngsight,
  });
  const [createCaseComment] = useMutation(CREATE_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });
  const [updateCaseComment] = useMutation(UPDATE_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });
  const [changeStatusCaseComment] = useMutation(CHANGE_STATUS_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });

  const [runQueryAdditionalDataQuestionsByForm] = useLazyQuery(
    ADDITIONAL_DATA_QUESTIONS_BY_FORM,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data.additionalDataQuestionsByForm) {
          setAdditionalDataPreview([...data.additionalDataQuestionsByForm]);
        }
      },
    }
  );

  const [runQueryPoliciesByCase] = useLazyQuery(POLICIES_BY_CASE, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.policiesByCase?.length > 0) {
        let listOfPolicies = data?.policiesByCase?.map((item) => {
          return {
            value: item?.idMainPolicy,
            label: item?.policyName,
          };
        });
        setMyListPolicies([...listOfPolicies]);
      }
    },
  });

  const [
    runQuerySubPoliciesByMainPolicies,
    { loading: loadingSubPoliciesByMainPolicies },
  ] = useLazyQuery(SUBPOLICIES_BY_MAIN_POLICY, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.subPoliciesByMainPolicy?.length > 0) {
        let listOfSubPolicies = data?.subPoliciesByMainPolicy?.map((item) => {
          return {
            value: item?.idSubPolicy,
            label: item?.subPolicyName,
          };
        });
        setMySubPolicies(listOfSubPolicies);
      }
    },
  });

  const [runQueryQueuesByCase] = useLazyQuery(QUEUES_BY_CASE, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.queuesByCase?.nodes?.length > 0) {
        let listOfQueues = data.queuesByCase.nodes.map((item) => {
          return {
            value: item.idQueue,
            label: item.queueName,
          };
        });
        setMyListQueues([...listOfQueues]);
      }
    },
  });

  const [runQueryInsightPocsList] = useLazyQuery(INSIGHT_POCS_LIST, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.insightPocsList) {
        let listOfInsightPocs = data.insightPocsList.map((item) => {
          return {
            value: item.policyInsightPocId,
            label: item.policyInsightName,
          };
        });
        setMyListInsightsPoc([...listOfInsightPocs]);
      }
    },
  });

  const [runQueryAdditionalDataByCase] = useLazyQuery(
    ADDITIONAL_DATA_BY_CASE_ID,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.additionalDataByCaseId) {
          setBeforeAdditionalData(data.additionalDataByCaseId);
        }
      },
    }
  );

  const [runQueryPermissionsByCase] = useLazyQuery(PERMISSIONS_BY_CASE, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.permissionsByCase) {
        setPermissions(data.permissionsByCase);
      }
    },
  });

  const [runQueryCaseById, { loading: loadingQueryCaseById }] = useLazyQuery(
    CASE_BY_ID,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.caseById) {
          setCaseDetail({ ...data.caseById });
        }
      },
    }
  );

  const [runQueryNextCaseStatusesByCase] = useLazyQuery(
    NEXT_CASE_STATUSES_BY_CASE,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.nextCaseStatusesByCase) {
          let allActionsByCase = data.nextCaseStatusesByCase.map((item, i) => {
            return { value: item.idCaseStatus, label: item.statusName };
          });
          setActionsList([...allActionsByCase]);
        }
      },
    }
  );

  const [runQueryCommentsByCaseId] = useLazyQuery(COMMENTS_BY_CASE_ID, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.commentsByCaseId) {
        setComments([...data.commentsByCaseId]);
      }
    },
  });

  const handleGoBack = () => {
    history.push({ pathname: "/MyCases" });
  };

  let handleCreateComment = (data) => {
    if (data.idCase && data.comment) {
      createCaseComment({
        variables: {
          idCase: data.idCase,
          comment: data.comment,
        },
      })
        .then((res) => {
          if (res.data.createCaseComment) {
            NotificationManager.success(
              "Comment is created successfully",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleUpdateComment = (data, smiley, ilike) => {
    if (data.idCaseComment && data.comment) {
      updateCaseComment({
        variables: {
          idCaseComment: data.idCaseComment,
          comment: data.comment,
          smiley: smiley ? `${smiley}` : "",
          ilike: ilike ? `${ilike}` : "",
        },
      })
        .then((res) => {
          if (res.data.updateCaseComment) {
            NotificationManager.success(
              "Comment is updated successfully",
              "",
              5000
            );
            setIsEditComment(false);
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleCancelUpdateComment = () => {
    setIsEditComment(!isEditComment);
  };

  let handleEditComment = (item) => {
    setIsEditComment(!isEditComment);
    if (item.idCaseComment) {
      setCommentData({
        idCase: item.idCase,
        idCaseComment: item.idCaseComment,
        comment: item.comment,
      });
    }
  };

  let handleDeleteComment = (data) => {
    if (data.idCaseComment && data.comment) {
      changeStatusCaseComment({
        variables: {
          idCaseComment: data.idCaseComment,
          newCommentStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res.data.changeStatusCaseComment) {
            NotificationManager.success(
              "Comment is deleted successfully",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleUpdateAddionalData = (data) => {
    let answers = [];
    if (data.policyCaseAdditonalDataSubPolicies) {
      let subPoliciesValue = data.policyCaseAdditonalDataSubPolicies.map(
        (item) => {
          return {
            idAdditionalDataQuestionSelected: data.subPoliciesIdDataQuestion,
            answer: JSON.stringify(item),
            fileAttachedBase64: null,
          };
        }
      );
      let policyValue = {
        idAdditionalDataQuestionSelected: data.policiesIdDataQuestion,
        answer: JSON.stringify(data.policyCaseAdditonalDataPolicies),
        fileAttachedBase64: null,
      };
      subPoliciesValue.push(policyValue);
      answers.push(...subPoliciesValue);
    }
    if (data.policyCaseAdditonalDataQueues.length >= 1) {
      let queues = data.policyCaseAdditonalDataQueues.map((item) => {
        if (item.queue) {
          return {
            idAdditionalDataQuestionSelected: data.queuesIdDataQuestion,
            answer: JSON.stringify(item.queue),
            fileAttachedBase64: null,
          };
        } else {
          return {
            idAdditionalDataQuestionSelected: data.queuesIdDataQuestion,
            answer: JSON.stringify(item),
            fileAttachedBase64: null,
          };
        }
      });
      answers.push(...queues);
    }
    if (data.policyCaseAdditonalDataInsightPocs.length >= 1) {
      let insightsPocs = {
        idAdditionalDataQuestionSelected: data.insightPocsIdDataQuestion,
        answer: `${data.policyCaseAdditonalDataInsightPocs.label
            ? JSON.stringify(data.policyCaseAdditonalDataInsightPocs)
            : JSON.stringify(
              data.policyCaseAdditonalDataInsightPocs[0][0].policyInsightPoc
            )
          }`,
        fileAttachedBase64: null,
      };
      answers.push(insightsPocs);
    }
    if (data.timeUnit.value) {
      let timeUnit = {
        idAdditionalDataQuestionSelected: data.timeUnitIdDataQuestion,
        answer: `${data.timeUnit.value.toUpperCase()}`,
        fileAttachedBase64: null,
      };
      answers.push(timeUnit);
    }
    if (data.benefitEuros) {
      let primaryBenefit = {
        idAdditionalDataQuestionSelected: data.benefitEurosIdDataQuestion,
        answer: `${data.benefitEuros}`,
        fileAttachedBase64: null,
      };
      answers.push(primaryBenefit);
    }
    if (data.otherBenefit1) {
      let secondaryBenefit = {
        idAdditionalDataQuestionSelected: data.otherBenefit1IdDataQuestion,
        answer: `${data.otherBenefit1}`,
        fileAttachedBase64: null,
      };
      answers.push(secondaryBenefit);
    }
    if (data.fileAttached.name || data.fileAttached) {
      let fileAttached = {
        idAdditionalDataQuestionSelected: data.fileAttachedIdDataQuestion,
        answer: `${data.fileAttached.name ? data.fileAttached.name : data.fileAttached
          }`,
        fileAttachedBase64: data.fileAttachedBase64,
      };
      answers.push(fileAttached);
    }
    createAdditionalDataByCaseId({
      variables: {
        caseId: detail?.idCase,
        answers: [...answers],
      },
    })
      .then((res) => {
        if (res.data.createAdditionalDataByCaseId) {
          NotificationManager.success(
            "additional data is created successfully",
            "",
            5000
          );
          setOpenAlert(data);
          setModalAlertTitle(true);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleSendChanges = (data) => {
    if (isEditComment) {
      NotificationManager.warning(
        "You haven't saved the changes on your comments",
        "",
        5000
      );
    } else {
      setOpenAlert(data);
      setModalAlertTitle(true);
    }
  };

  let handleChangeSelectAction = (action) => {
    setActionSelected(action);
  };

  let handleSaveAction = (data) => {
    if (actionSelected) {
      changeStatusCase({
        variables: {
          caseId: detail.idCase,
          newCaseSatus: `${actionSelected.label
            .toUpperCase()
            .replaceAll(" ", "_")}`,
        },
      })
        .then((res) => {
          if (res.data.changeStatusCase) {
            NotificationManager.success(
              "Case status is updated successfully",
              "",
              5000
            );
            setOpenAlert(null);
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleChangeMainPolicy = (event) => {
    runQuerySubPoliciesByMainPolicies({
      variables: {
        caseId: detail.idCase,
        policyId: event.value,
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
  };

  useEffect(() => {
    if (location.state.detail) {
      setDetail(location.state.detail);
    }
  }, []);

  useEffect(() => {
    if (detail?.idCase) {
      runQueryCaseById({
        variables: {
          caseById: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryCommentsByCaseId({
        variables: {
          idCase: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryNextCaseStatusesByCase({
        variables: {
          caseId: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryPoliciesByCase({
        variables: {
          caseId: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryQueuesByCase({
        variables: {
          caseId: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryInsightPocsList().catch((err) =>
        NotificationManager.error(err.message, "", 5000)
      );
      runQueryPermissionsByCase({
        variables: {
          caseId: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryAdditionalDataByCase({
        variables: {
          caseId: detail.idCase,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      runQueryAdditionalDataQuestionsByForm({
        variables: {
          formId: detail.idForm,
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
    }
  }, [detail, renderAgain]);

  useEffect(() => {
    if (detail?.status) {
      if (detail.status.toUpperCase() === `NEW`) {
        changeStatusCase({
          variables: {
            caseId: detail.idCase,
            newCaseSatus: `UNDER_INTERNAL_REVIEW`,
          },
        })
          .then((res) => {
            if (res.data.changeStatusCase) {
              setOpenAlert(null);
              setrenderAgain(!renderAgain);
            }
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      }
    }
  }, [detail]);

  return (
    <GeneralContainer>
      <ContainerBack>
        <div style={{ margin: "1em 1em 0em 4em", width: "60vw" }}>
          <ContentPrincipalTitle>
            <p>My Cases</p>
          </ContentPrincipalTitle>
          <ContentHr>
            <Hr />
          </ContentHr>
          <ButtonBack className="m-3" onClick={() => handleGoBack()}>
            <BackArrow></BackArrow>
          </ButtonBack>
          {caseDetail?.idFormNavigation?.name && (
            <SpanForm>{`${caseDetail.idFormNavigation.name}`}</SpanForm>
          )}
          <span style={{ margin: "0.5em" }}>|</span>
          {caseDetail?.idCase && (
            <SpanCaseId>ID: {caseDetail.idCase}</SpanCaseId>
          )}
        </div>
        <div style={{ width: "40vw" }}>
          {caseDetail && (
            <ContentCard>
              <ContentHeaderCard>
                <TitleCard>{caseDetail?.idFormNavigation?.name}</TitleCard>
              </ContentHeaderCard>
              <ContentHr>
                <Hr />
              </ContentHr>
              <ContentFooterCard>
                <ContentLeftCard>
                  <TextInternalCard>Internal Review</TextInternalCard>
                  <TextCountComments>
                    <TextsmsIcon style={{ fontSize: "12px" }} />{" "}
                    {caseDetail?.totalComments} Comments
                  </TextCountComments>
                </ContentLeftCard>
                <ContentRightCard>
                  <TextDateCard>
                    {moment(caseDetail?.createDate).format("YYYY-MM-DD")}
                  </TextDateCard>
                  <TextIdCard>ID: {caseDetail?.idCase}</TextIdCard>
                </ContentRightCard>
              </ContentFooterCard>
            </ContentCard>
          )}
        </div>
      </ContainerBack>
      <Hr className="ml-1" color={themeConfig.text.primary} />
      <MyCaseDetailComponent
        comments={comments}
        policyQuestionAnswers={caseDetail.policyQuestionAnswers}
        idCase={caseDetail.idCase}
        caseStatus={caseDetail.status}
        commentData={commentData}
        setCommentData={setCommentData}
        isEditComment={isEditComment}
        handleCreateComment={handleCreateComment}
        handleUpdateComment={handleUpdateComment}
        handleEditComment={handleEditComment}
        handleDeleteComment={handleDeleteComment}
        handleUpdateAddionalData={handleUpdateAddionalData}
        handleCancelUpdateComment={handleCancelUpdateComment}
        handleSendChanges={handleSendChanges}
        myListPolicies={myListPolicies}
        handleChangeMainPolicy={handleChangeMainPolicy}
        mySubPolicies={mySubPolicies}
        myListQueues={myListQueues}
        myListInsightsPoc={myListInsightsPoc}
        additionalData={additionalData}
        beforeAdditionalData={beforeAdditionalData}
        permissions={permissions}
        additionalDataPreview={additionalDataPreview}
        loadingQueryCaseById={loadingQueryCaseById}
        loadingSubPoliciesByMainPolicies={loadingSubPoliciesByMainPolicies}
      />
      {openAlert && (
        <ModalConfirmCaseUpdated
          modalTitle={"Alert"}
          title={
            modalAlertTitle
              ? "Cases Successfully Updated"
              : "Cases Error for Update"
          }
          modalAlertTitle={modalAlertTitle}
          labelSelect={"Please select the next action for this case:"}
          actionsList={actionsList}
          actionSelected={actionSelected}
          handleChangeSelectAction={handleChangeSelectAction}
          setOpen={setOpenAlert}
          open={openAlert}
          fn={handleSaveAction}
          isLockerSelector={
            permissions
              .map((item) => item.actionName)
              .indexOf("ChangeStatus") !== -1
              ? false
              : true
          }
        />
      )}
    </GeneralContainer>
  );
};

export default MyCaseDetailContainer;
